import Swal from 'sweetalert2';

/**
 * Branded SweetAlert notifications for Experts Communication
 */
export const showSuccessAlert = (title = 'Success!', text = 'Your submission has been received successfully.') => {
  return Swal.fire({
    title,
    text,
    icon: 'success',
    confirmButtonColor: '#C60C0D',
    confirmButtonText: 'OK',
    timer: 4500,
    timerProgressBar: true
  });
};

export const showErrorAlert = (title = 'Error', text = 'Something went wrong. Please try again or reach out to us directly.') => {
  return Swal.fire({
    title,
    text,
    icon: 'error',
    confirmButtonColor: '#C60C0D',
    confirmButtonText: 'OK'
  });
};

export const showWarningAlert = (title = 'Attention Required', text = 'Please check the required fields and try again.') => {
  return Swal.fire({
    title,
    text,
    icon: 'warning',
    confirmButtonColor: '#C60C0D',
    confirmButtonText: 'OK'
  });
};

export const showLoadingAlert = (title = 'Submitting Application...', text = 'Please wait while we upload your CV and process your application.') => {
  return Swal.fire({
    title,
    text,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });
};

export const closeLoadingAlert = () => {
  Swal.close();
};

export { Swal };
export default Swal;
